export default __webpack_public_path__ + "static/media/landing-page-banner.589e2e12.png";